import { Component, ElementRef } from '@angular/core';
import { LanguageService, MessageService, ModalBase } from '../components/index';
import { LocaleModalAdresseComponent } from '../locales/localeModalAdresseComponent';
@Component({
  selector: 'retail-modal-no-geom-warning',
  templateUrl: './modal-no-geom-warning.component.html',
  styleUrls: ['./modal-no-geom-warning.component.css']
})
export class ModalNoGeomWarningComponent extends ModalBase {
  isOpen: boolean = false;
  rowId!: any;
  
  constructor(private host: ElementRef<HTMLElement>, private languageService: LanguageService,
    private messageService: MessageService) { 
    super();
    this.languageService.addTranslation('ModalAdresseComponent', new LocaleModalAdresseComponent().locale);
  }

  async open() {
    if (!localStorage.getItem('dontShowGeoWarn')) {
      this.isOpen = true;
    }
  }

  closeNoGeoModal(useBtn: boolean) {
    // get checkbox value
    const checkboxValue = (document.getElementById('no_geom_' + this.rowId) as HTMLInputElement).checked;
  
    if (useBtn && checkboxValue) {
      localStorage.setItem('dontShowGeoWarn', 'true');
    }
    this.isOpen = false;
  }
}
